import { useGameContainer } from '../index';
import dayjs from 'dayjs';
import NewsFeed from '@/components/modules/NewsFeed';
import { getGenderSportCoverImageSrc } from '@/components/GenderSportCoverImage';
import ContentSection, { ContentSectionHeader } from '@/components/ContentSection';
import { SectionHeaderSize } from '@/components/SectionHeader';

export default function GameLatestNews() {
  const [{ game }] = useGameContainer();

  const newsItems = game.gameTeams
    .map(gameTeam => gameTeam.team.previousGames.nodes)
    .flat()
    .filter(game => !!game.headline)
    .sort((a, b) => dayjs(b.date).diff(dayjs(a.date)));

  // take out duplicate games
  const ids = newsItems.map(o => o.id);
  const filteredNewsItems = newsItems.filter(({ id }, index) => !ids.includes(id, index + 1));

  if (filteredNewsItems.length == 0) return null;

  return (
    <ContentSection>
      <ContentSectionHeader size={SectionHeaderSize.LARGE}>News & Updates</ContentSectionHeader>
      <NewsFeed games={filteredNewsItems} defaultImage={getGenderSportCoverImageSrc(game.genderSport.key)} />
    </ContentSection>
  );
}
